import { triggerHostMessageMinimizeWidget } from '../triggerHostMessage/triggerHostMessageMinimizeWidget';
export default function minimizeCallingWidget(shouldMinimize) {
  triggerHostMessageMinimizeWidget(shouldMinimize);
}